import { RouterProvider } from "react-router-dom";
import LinearProgress from "@mui/material/LinearProgress";
import Stack from "@mui/material/Stack";
import { useAuth } from "../hooks/useAuth";
import { router as RootRouter } from "./RootRoutes";
import { router as AuthRoutes } from "./AuthRoutes";

const Routes = () => {
  const { loading, midia } = useAuth();

  if (loading) {
    return (
      <Stack
        width="100vw"
        height="100vh"
        alignItems="center"
        justifyContent="center"
        rowGap={2}
      >
        <LinearProgress sx={{ width: "30%" }} color="primary" />
      </Stack>
    );
  }

  if (midia) {
    return <RouterProvider router={RootRouter} />;
  } else {
    return <RouterProvider router={AuthRoutes} />;
  }
};

export default Routes;
